/* @ngInject */
const pieceLocal = (

) => {
  const self = {}

  return self
}
export default pieceLocal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/services/local.service.js